module.exports = __webpack_public_path__ + "img/countersink.f6dcfa37.png";